import React, {useContext, useState} from 'react';
import SideNavBar from '../SideNavBar/SideNavBar';
import {pages} from './SideBarPages';
import {useNavigate} from 'react-router-dom';
import {StateContext, DispatchContext} from '../../../../store';
import {Images} from '../../../../common/Assets/Images';
import {logout} from '../../../../services/AuthServices';
import {SNACKBAR_OPEN} from '../../../../reducers';
import './SideBar.css';
const IMAGE_URL =
  process.env.REACT_APP_IMAGE_URL || "https://museum.systems.gov.bt";

export const SideBar = props => {
  const {open, variant, onClose, children, ...rest} = props;
  const navigate = useNavigate();
  const dispatch = useContext(DispatchContext);
  const [activeKey, setActiveKey] = React.useState(1);
  const [openKeys, setOpenKeys] = React.useState([]);
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const user = JSON.parse(localStorage.getItem('user'));
  const profilePhoto = user?.profile?.photo;
  
  // More robust URL validation and construction
  const isValidUrl = (url) => {
    try {
      new URL(url);
      return true;
    } catch {
      return false;
    }
  };
  
  const profileImage = profilePhoto && profilePhoto.trim() && isValidUrl(IMAGE_URL) ? 
    `${IMAGE_URL.replace(/\/$/, '')}/${profilePhoto.replace(/^\//, '')}` : 
    Images.logoWhite;
    

  const formatText = (text) => {
    if (!text) return '-';
    return text
      .replace(/_/g, ' ')
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };

  const handleLogoutClick = () => {
    setShowLogoutConfirm(true);
  };

  const handleLogoutConfirm = () => {
    logout(dispatch).then(response => {
      navigate('/');
      dispatch({type: SNACKBAR_OPEN, payload: {isNotify: true, severity: 'success', message: 'Logout successful'}});
    });
    setShowLogoutConfirm(false);
  };

  const handleLogoutCancel = () => {
    setShowLogoutConfirm(false);
  };

  return (
    <>
      <div
        className={`sidebar-container fixed left-0 top-0 h-full w-60 bg-[#F5F5F7] shadow-lg transition-transform duration-300 z-50 flex flex-col ${
          open ? 'translate-x-0' : '-translate-x-full'
        } ${variant === 'permanent' ? '!translate-x-0' : ''}`}
        {...rest}
      >
      <div className="pt-8 pb-6 border-b border-gray-300 bg-[#E9EFFB]">
        <div className="flex justify-center cursor-pointer mb-4" onClick={() => navigate('/management/profile')}>
          <img
            draggable={false}
            className="w-20 h-20 rounded-full border-[3px] border-[#5B6B8F] object-cover"
            src={profileImage}
            alt="profile"
          />
        </div>
        <div className="text-center px-4">
          <p className="text-[#2C3E50] text-base font-semibold mb-1">
            {formatText(user?.username || user?.first_name)}
          </p>
          <h2 className="text-[#5B6B8F] text-sm font-medium tracking-wide" style={{fontFamily: 'Libre Baskerville', marginTop: '-10px'}}>
            {formatText(user?.current_role?.name) || 'Museum Admin'}
          </h2>
        </div>
      </div>
      <div className="flex-1 overflow-y-auto no-scrollbar">
        <SideNavBar
          activeKey={activeKey}
          openKeys={openKeys}
          onSelect={setActiveKey}
          onOpenChange={setOpenKeys}
          children={children}
          pages={pages}
          onClose={onClose}
        />
      </div>
      
      <div className="mt-auto border-t border-gray-300">
        <button
          onClick={handleLogoutClick}
          className="w-full text-left px-5 py-4 text-[15px] font-normal text-[#4A5568] hover:bg-white transition-colors flex items-center gap-3"
        >
          <svg
            className="w-5 h-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
            />
          </svg>
          Logout
        </button>
      </div>
      </div>

      {/* Logout Confirmation Dialog - Centered on entire page */}
      {showLogoutConfirm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]">
          <div className="bg-white rounded-lg shadow-xl p-6 max-w-sm w-full mx-4">
            <h3 className="text-lg font-semibold text-gray-900 mb-2">Confirm Logout</h3>
            <p className="text-gray-600 mb-6">Are you sure you want to logout?</p>
            <div className="flex gap-3 justify-end">
              <button
                onClick={handleLogoutCancel}
                className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-md transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={handleLogoutConfirm}
                className="px-4 py-2 text-sm font-medium text-white bg-red-600 hover:bg-red-700 rounded-md transition-colors"
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
